<template>
    <div id="app" class="global-wrapper">
        <loading/>
        <router-view name="header"/>
        <main>
            <section>
                <transition name="fade">
                    <router-view/>
                </transition>
            </section>
        </main>
        <w-version/>
    </div>
</template>

<script>

import Loading from './components/Loading'

export default {
    components: { Loading },
    name: 'App'
}
</script>

<style lang="scss">
    @import "assets/css/normalize.css";
    /*@import "assets/css/custom-bootstrap.css";*/

    .fade-enter-active,
    .fade-leave-active {
        transition-property: opacity;
        transition-duration: .7s;
    }

    .fade-enter-active {
        transition-delay: .7s;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

    html {
        height: 100%;
    }

    body, .global-wrapper {
        /*height: 100%;*/
        /*overflow: scroll;*/
    }

    .global-wrapper {
        padding-top: 44px;
    }
</style>
